import { useTypedRouteLoaderData } from './useTypedRouteLoaderData';

/**
 * The label the navigation tab shows for `category` (a MenuTab value, e.g.
 * 'flower' or 'specials'), so page titles read the same as the tab.
 */
export function useDisplayCategoryLabel(
  category: string,
  fallback?: string
): string | undefined {
  const menuLayoutData = useTypedRouteLoaderData('routes/_menu');

  return (
    menuLayoutData?.displayCategories.find(({ value }) => value === category)
      ?.label ?? fallback
  );
}
